import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../../theme';

export const useQuotePackageListStyles = createStyles(({ token }) => ({
  quotesFormPackageSummary: {
    justifyContent: 'space-between',
    padding: `${ThemeSpaces.SPACE_NORM0_5}px ${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM}px`,

    [`@media (min-width: ${token.screenMDMin}px)`]: {
      padding: `${ThemeSpaces.SPACE_NORM0_5}px ${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM}px`,
    },
  },
}));
